import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Table from "../../../components/elements/table/Table";

import { setTitle } from "../../../helpers/MetaTag";

import { handleFilterChange, initialsValue } from "../../../helpers";
import DeleteModal from "../../../components/common/DeleteModal";
import { useDebounce } from "../../../hooks/useDebounce";
import LimitSelect from "../../../components/elements/LimitSelect";
// import { useGetPermission } from "../../hooks/useGetPermission";
import Search from "../../../components/form/Search";
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import dayjs from "dayjs";

import Badge from "../../../components/elements/Badge";

import OrderDetailsDrawer from "./drawer/OrderDetailsDrawer.js";
import { useNavigate } from "react-router-dom";
import Indentification from "../../../components/elements/Indentification";

import useFetch from "../../../hooks/useFetch";
import useMutation from "../../../hooks/useMutation";

import { changeStatus, orderList } from "../../../services/orderService.js";
import Modal from "../../../components/elements/Modal.js";
import Select from "../../../components/form/Select.js";
import Textarea from "../../../components/form/Textarea.js";
import Button from "../../../components/forms/Button.js";

const Orders = ({ userId }) => {
  const statusNotes = {
    confirmed: "Your order has been confirmed and is moving to the next stage.",
    processing:
      "Your order has been received and is currently being prepared for confirmation stage.",
    shipped:
      "Your order has been packaged and dispatched. It's on its way to you!",
    delivered:
      "Your order has been successfully delivered to the address provided. We hope you enjoy your personalized coloring book!",
    // pickup: "The order is ready for pickup.",
    outForDelivery: "Package is out with courier",
    canceled:
      "Your order has been cancelled, either by request or due to an issue before shipping.",
    returnRequest:
      "A return has been requested for your order. We're reviewing the request.",
    returnConfirmed:
      "Your return request has been approved. We'll guide you through the next steps.",
    // rejected: "The item was rejected or returned by the customer.",
  };
  setTitle("Orders");
  //   const { permission, status } = useGetPermission("faq");

  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [modal, setModal] = useState({
    isOpen: false,
    data: {},
    loading: false,
  });
  const [list, setList] = useState({ data: [] });
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  //   const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });
  const [detailsModal, setDetailsModal] = useState({
    isOpen: false,
    data: null,
  });
  useEffect(() => {
    if (userId) {
      setFilters((prev) => ({
        ...prev,
        userId: [userId],
      }));
    }
  }, [userId]);

  const shouldFetch = userId && filters?.userId?.length > 0;
  const { data, isLoading, updateData, isFetching, refetch } = useFetch({
    enabled: shouldFetch,
    dependencies: ["order", filters, search],
    fetchFunction: async () => {
      const { userId = [], ...restFilters } = filters || {};
      const isSingleUser = userId.length === 1 && typeof userId[0] === "string";
      const res = await orderList({
        // ...filters,
        ...restFilters,
        // type: "admin",
        // ...Object.fromEntries(userId.map((val, i) => [`userId[${i}]`, val])),
        ...(isSingleUser
          ? { userId: userId[0] } // 👉 Single userId param for URL: ?userId=xyz
          : {
              // 👉 Admin case: array of userIds with indices + type=admin
              ...Object.fromEntries(
                userId.map((val, i) => [`userId[${i}]`, val])
              ),
              type: "admin",
            }),

        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  //   const handleDownloadReceipt = async (item) => {
  //     const fileName = `Receipt-${item?.invoiceId || "N/A"}.pdf`;
  //     const blob = await pdf(<DonationReciptPdf data={item} />).toBlob();
  //     fileSaver.saveAs(blob, fileName);
  //   };

  const { mutate: updateStatus, isPending } = useMutation({
    mutationFn: changeStatus,
    onSuccess: async (res) => {
      if (res?.status === 200) {
        toast.success("Order status updated.");
        await refetch(); // ✅ Refetch updated orders
        setModal({ isOpen: false, data: null, loading: false });
      } else {
        toast.error(res?.message || "Failed to update status.");
        setModal((prev) => ({ ...prev, loading: false }));
      }
    },
    onError: () => {
      toast.error("Something went wrong.");
      setModal((prev) => ({ ...prev, loading: false }));
    },
  });
  const onSaveChangeStatus = () => {
    setModal((prev) => ({ ...prev, loading: true }));

    const payload = {
      orderId: modal?.data?._id,
      status: modal?.data?.status?.info || modal?.data?.status,
    };

    updateStatus(payload);
  };

  const tableHeadData = [
    {
      _id: 2,
      name: "Name",
      align: "left",
    },
    {
      _id: 3,
      name: "Email",
      align: "left",
    },
    {
      _id: 4,
      name: "Order Id",
      align: "left",
    },
    {
      _id: 5,
      name: "Invoice Number",
      align: "left",
    },
    // {
    //   _id: 5,
    //   name: "Plan Name",
    //   align: "left",
    //   isFilter: true,
    //   isFilterSearch: false,
    //   onFilter: (val) => {
    //     if (val?.length > 0) {
    //       setFilters((prev) => ({
    //         ...prev,
    //         planId: val.map((item) => item.value),
    //       }));
    //     } else {
    //       setFilters((prev) => {
    //         delete prev.planId;
    //         return { ...prev };
    //       });
    //     }
    //   },
    //   filterData: (plans?.data || []).map((plan) => ({
    //     value: plan._id,
    //     name: plan.name,
    //     type: "checkbox",
    //   })),
    // },
    // {
    //   _id: 6,
    //   name: "Type",
    //   align: "left",
    // },
    {
      _id: 9,
      name: "Date",
      align: "left",
    },
    // {
    //   _id: 10,
    //   name: "Payment Method",
    //   align: "left",
    // },
    {
      _id: 11,
      name: "Status",
      align: "left",
    },
    {
      _id: 13,
      name: "Action",
      align: "left",
    },
  ];
  const navigate = useNavigate();

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="relative flex items-center cursor-pointer">
              <div
                className="text-md mx-2 text-slate-600 font-bold"
                onClick={(e) => setDetailsModal({ isOpen: true, data: item })}
              >
                {item?.user?.firstName + " " + item?.user?.lastName || "-"}
              </div>
            </div>
          ),
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.user?.email || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.orderId || "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.invoiceNumber || "-",
        },
        // {
        //   _id: 6,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: item?.paymentType || "-",
        // },
        {
          _id: 9,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.createdAt
            ? dayjs(item?.createdAt).format("DD MMM, YYYY")
            : "-",
        },
        // {
        //   _id: 10,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: <PaymentMethod type={item?.paymentMethod} />,
        // },
        {
          _id: 11,
          type: "status",
          align: "left",
          statusLabel: item?.status,
          statusType:
            item?.status === "processing"
              ? "warning"
              : item?.status === "confirmed"
              ? "success"
              : item?.status === "shipped"
              ? "info"
              : item?.status === "delivered"
              ? "success"
              : item?.status === "outForDelivery"
              ? "secondary"
              : item?.status === "returnRequest"
              ? "danger"
              : item?.status === "returnConfirmed"
              ? "secondary"
              : item?.status === "canceled"
              ? "danger"
              : "gray",
          functions: () => {
            setModal({
              isOpen: true,
              data: {
                ...item,
                status: {
                  info: item?.status,
                  note: statusNotes[item?.status] || "",
                },
              },
            });
          },
        },
        {
          _id: 12,
          type: "action",
          align: "left",
          // cellClass: "w-[5%]",
          actionData: [
            {
              _id: 1,
              name: "View Details",
              icon: "fa-solid fa-eye",
              onClick: () => {
                setDetailsModal({ isOpen: true, data: item });
              },
            },
            // {
            //   _id: 4,
            //   name: "Delete",
            //   icon: "fa-regular fa-trash-can",
            //   standout: true,
            //   onClick: () => {
            //     setDeleteModal({
            //       isOpen: true,
            //       data: item,
            //     });
            //   },
            // },
          ],
        },
      ],
    };
  });

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          Orders Management
        </div>
        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
            />
          </div>
        </div>
      </div>

      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        isFetching={isFetching}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />

      <OrderDetailsDrawer
        open={detailsModal?.isOpen}
        data={detailsModal?.data}
        close={() => setDetailsModal({ isOpen: false, data: null })}
      />

      {/* <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      /> */}

      <Modal
        isOpen={modal?.isOpen}
        setIsOpen={() => setModal({ isOpen: false })}
        title="Update Status"
        size="lg"
        bodyClass="!flex !flex-col"
      >
        <Select
          label="Status"
          placeholder={"Select Order Status"}
          selectedValue={modal?.data?.status?.info || modal?.data?.status}
          dropdownData={[
            { value: "confirmed", name: "Confirmed" },
            { value: "processing", name: "Processing" },
            { value: "shipped", name: "Shipped" },
            { value: "delivered", name: "Delivered" },
            { value: "outForDelivery", name: "Out For Delivery" },
            { value: "returnRequest", name: "Return Request" },
            { value: "returnConfirmed", name: "Return Confirmed" },
            { value: "canceled", name: "Canceled" },
          ]}
          setSelectedValue={(val) => {
            setModal((prev) => ({
              ...prev,
              data: {
                ...prev.data,
                status: {
                  ...prev.data.status,
                  info: val,
                  note: statusNotes[val] || "",
                },
              },
            }));
          }}
        />

        <Textarea
          label="Note"
          inputValue={
            modal?.data?.status?.note || statusNotes[modal?.data?.status]
          }
          onChange={(e) =>
            setModal((prev) => ({
              ...prev,
              data: {
                ...prev.data,
                status: { ...prev.data.status, note: e.target.value },
              },
            }))
          }
          labelClasses="mt-4"
          inputClasses="!rounded-xl !p-6 !h-32"
        />

        <div className="flex justify-end gap-3 mt-6 pt-2 border-t">
          <Button
            buttonType="button"
            buttonLabel="Cancel"
            buttonIcon="fa-regular fa-xmark text-white"
            buttonLabelClasses="!text-white"
            buttonClasses="!bg-red-500"
            buttonFunction={() => setModal({ isOpen: false })}
          />
          <Button
            buttonLabel="Save"
            buttonIcon="fa-light fa-floppy-disk"
            buttonFunction={onSaveChangeStatus}
            loading={modal?.loading}
            isDisable={modal?.loading}
          />
        </div>
      </Modal>
    </div>
  );
};

export default Orders;
